import { ref } from 'vue'

export function useNextUtteranceCue() {
  const canSpeak = ref(false)
  const isBlocked = ref(false)
  let pendingTimer = null

  function beep({ freq = 660, durMs = 40, gain = 0.06 } = {}) {
    try {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext
      if (!AudioContextClass) return
      const ctx = new AudioContextClass()
      const osc = ctx.createOscillator()
      const g = ctx.createGain()
      osc.type = 'sine'
      osc.frequency.value = freq
      g.gain.value = 0
      osc.connect(g).connect(ctx.destination)
      const now = ctx.currentTime
      g.gain.linearRampToValueAtTime(gain, now + 0.001)
      g.gain.setValueAtTime(gain, now + Math.max((durMs - 3) / 1000, 0))
      g.gain.linearRampToValueAtTime(0.0, now + durMs / 1000)
      osc.start(now)
      osc.stop(now + durMs / 1000 + 0.01)
      osc.onended = () => ctx.close().catch(() => {})
    } catch {}
  }

  function clearTimer() {
    if (pendingTimer) {
      clearTimeout(pendingTimer)
      pendingTimer = null
    }
  }

  function blockNow({ playBeep = false } = {}) {
    clearTimer()
    isBlocked.value = true
    canSpeak.value = false
    if (playBeep) {
      beep({ freq: 520, durMs: 45, gain: 0.05 })
    }
  }

  function readyNow({ playBeep = true } = {}) {
    clearTimer()
    isBlocked.value = false
    canSpeak.value = true
    if (playBeep) {
      beep({ freq: 880, durMs: 50, gain: 0.05 })
    }
  }

  function blockThenReady(delayMs = 1000) {
    blockNow({ playBeep: true })
    pendingTimer = setTimeout(() => {
      readyNow({ playBeep: true })
    }, delayMs)
  }

  function reset() {
    clearTimer()
    isBlocked.value = false
    canSpeak.value = false
  }

  return { canSpeak, isBlocked, blockNow, readyNow, blockThenReady, reset }
}

